var _text, _text2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponsive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 168.783 543.8093)",
    fill: "#FFFF00",
    fontFamily: "'Verdana-Bold'",
    fontSize: 20
  }, "simpleicon.com")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 9.1931 567.8093)",
    fill: "#FFFF00",
    fontFamily: "'Verdana'",
    fontSize: 20
  }, "Collection Of Flat Icon, Symbols And Glyph Icons")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M265.229,364.383c-5.207-3.826-5.758-9.575-5.758-9.575l-1.951-12.473h-62.204l-1.957,12.473c0,0-0.544,5.749-5.748,9.575 c-5.198,3.83-9.306,7.113-5.198,7.669c3.955,0.531,41.256,0.048,44.008,0c2.759,0.048,40.052,0.531,44.011,0 C274.531,371.496,270.422,368.221,265.229,364.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.538,259.694c0-5.77-4.681-10.451-10.452-10.451H60.453c-5.771,0-10.453,4.681-10.453,10.451v109.718 c0,5.777,4.682,10.453,10.453,10.453h49.637c5.768,0,10.452-4.676,10.452-10.453V259.694H120.538z M80.085,261.002h10.451 c0.722,0,1.306,0.583,1.306,1.3c0,0.724-0.584,1.312-1.306,1.312H80.085c-0.722,0-1.308-0.592-1.308-1.312 C78.778,261.577,79.364,261.002,80.085,261.002z M84.875,373.685c-2.887,0-5.229-2.338-5.229-5.227 c0-2.885,2.342-5.227,5.229-5.227c2.885,0,5.225,2.334,5.225,5.227C90.1,371.347,87.764,373.685,84.875,373.685z M114.009,358.968 H56.531v-87.521h57.479V358.968z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.343,189.137H339.846c-8.095,0-14.657,6.558-14.657,14.655v153.854c0,8.096,6.563,14.662,14.657,14.662h107.497 c8.1,0,14.657-6.566,14.657-14.662V203.789C461.996,195.692,455.439,189.137,447.343,189.137z M372.548,364.153 c-4.047,0-7.334-3.274-7.334-7.318c0-4.048,3.287-7.33,7.334-7.33c4.04,0,7.315,3.282,7.315,7.33 C379.864,360.879,376.588,364.153,372.548,364.153z M393.591,364.153c-4.04,0-7.323-3.274-7.323-7.318 c0-4.048,3.283-7.33,7.323-7.33c4.052,0,7.326,3.282,7.326,7.33C400.917,360.879,397.647,364.153,393.591,364.153z  M414.654,364.153c-4.052,0-7.327-3.274-7.327-7.318c0-4.048,3.275-7.33,7.327-7.33c4.043,0,7.322,3.282,7.322,7.33 C421.976,360.879,418.697,364.153,414.654,364.153z M452.839,342.986H334.35V201.954h118.489V342.986L452.839,342.986z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.547,176.778h18.017v-32.629c0-6.639-5.379-12.014-12.014-12.014H88.287c-6.633,0-12.014,5.375-12.014,12.014v92.739 h18.021v-86.736h264.253V176.778L358.547,176.778z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.899,294.287v36.034h179.931v-36.034H132.899z M226.416,320.544c-4.548,0-8.24-3.693-8.24-8.24 c0-4.546,3.692-8.239,8.24-8.239c4.549,0,8.24,3.693,8.24,8.239C234.656,316.85,230.965,320.544,226.416,320.544z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.65d99c0d3de4e445086b8e391f38a75d.svg";
export { ForwardRef as ReactComponent };